<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0">
            <div class="h2">Новые мероприятия по отлову</div>
            <small><b-link :to="{ name: 'requestsDetail', params: { id: requestId } }">Заявка №{{ requestId }}</b-link></small>

            <b-row class="mt-4 mb-5" v-if="request">
                <b-col >
                    <div class="h4 mb-3">1. Рейд</div>
                    <div class="col-12 p-0">
                        <catching-raid-detail :request="request" @object-created="onRaidCreated"/>
                    </div>
                </b-col>
            </b-row>
            <base-catching-bulk-create v-if="raid && request" :raid="raid" :is-completable="false" />
        </b-card>
    </div>
</template>

<script>
import api from "@/api";
import httpClient from "@/http";
import {Request} from "@/pages/AppPages/Requests/request";
import {Raid} from "@/pages/AppPages/Raids/raid";
import CatchingRaidDetail from "@/pages/AppPages/Events/Catching/CatchingRaidDetail.vue";
import BaseCatchingBulkCreate from "@/pages/AppPages/Events/Catching/BaseCatchingBulkCreate.vue";

export default {
    name: "RequestMonitoringBulkCreate",
    components: {BaseCatchingBulkCreate, CatchingRaidDetail},
    data() {
        return {
            raid: null,
            request: null
        }
    },
    computed: {
        requestId() {
            return parseInt(this.$route.params.id)
        },
    },
    methods: {
        fetchRequest() {
            const vm = this;
            return new Promise((resolve, reject) => {
                const requestUrl = api.requests.default.detail(vm.requestId);
                httpClient.get(requestUrl).then(response => {
                    vm.request = new Request();
                    vm.request.applyData(response.data);
                    resolve();
                }).catch(reason => {
                    vm.$bvToast.toast(reason, { title: 'Ошибка при получении информации о заявке с сервера', variant: 'danger'})
                    reject();
                });
            })
        },
        onRaidCreated(data) {
            this.raid = new Raid({request: this.request});
            this.raid.applyData(data);
            this.$bvToast.toast(`Рейд №${this.raid.id} создан`, {
                    solid: true,
                    noCloseButton: true,
                    variant: 'success'
                });

            setTimeout(() => {
                this.$router.replace({ name: 'raidMonitoringCreate', params: { raidId: this.raid.id } })
            }, 200)

        },
    },
    mounted() {
        this.fetchRequest();
    }
}
</script>

<style scoped>

</style>